module.exports = __webpack_public_path__ + "img/garten1.bbc2fe62.jpg";